/// <reference types="vite-plugin-svgr/client" />
import { Box, Container, Grid, Link as MuiLink } from '@mui/material';
import { Outlet, Link } from 'react-router-dom';

import LogoBlack from '../assets/images/logo-black.svg?react';
import { useManageChat } from '~/modules/@shared/hooks/useManageChat';

export function StaffInvitationLayout() {
  useManageChat({ close: true });

  return (
    <Box sx={{ backgroundColor: 'background.secondary' }}>
      <Grid container sx={{ minHeight: '100vh', maxHeight: '100vh', overflowY: 'hidden' }}>
        <Grid item>
          <Box
            sx={{
              minHeight: '100vh',
              minWidth: '100vw',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: 'background.secondary',
              py: 3.75,
            }}>
            {/* Logo */}
            <MuiLink component={Link} to="/" sx={{ width: 116, display: 'inline-block' }}>
              <LogoBlack />
            </MuiLink>

            <Container
              sx={{
                mt: 6,
                mb: 4,
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <Outlet />
            </Container>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
